import styled from "styled-components";

export const Styles = styled.div`
  overflow: hidden;
  .ml-1 {
    margin-left: 10px;
  }
  .row {
    display: flex;
    margin-top: 4px;

    .search-input {
      flex: 1;
      margin-right: 10px;
    }

    .wrap-select-client {
      flex: 1;
      z-index: 100000;
      margin-right: 10px;
    }
  }

  .group-btn {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .project-container {
    background-color: #fff;
    padding: 16px;

    .ant-spin-nested-loading {
      &:last-child {
        width: 100%;
      }
    }
  }

  .see-more {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 20px;
    text-decoration: underline;
    color: #174a83;
    font-weight: 600;
    cursor: pointer;
  }

  .project-header {
    margin-bottom: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e3666;
  }

  .gantt-chart {
    width: 100%;

    .group-btn {
      margin-bottom: 0;
      padding: 10px;
      border-top: 1px solid #bcbcbc;
      border-left: 1px solid #bcbcbc;
      border-right: 1px solid #bcbcbc;

      .diabled {
        color: rgba(0, 0, 0, 0.25);
        border-color: #d9d9d9;
        background: #f5f5f5;
        text-shadow: none;
        box-shadow: none;
      }
    }
    .date-control {
      gap: 10px;
      border-top: 1px solid #bcbcbc;
      border-left: 1px solid #bcbcbc;
      border-right: 1px solid #bcbcbc;
      padding: 4px 0;
      height: 64px;

      .wrap-button {
        display: flex;
        flex-direction: row;
      }
      .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      p {
        font-weight: 600;
        font-size: 16px;
        color: #1c1e21;
        transform: translateY(2px);
      }

      svg {
        cursor: pointer;
      }
    }
  }

  .project-info {
    padding-left: 3px;
    display: flex;
    justify-content: flex-start;
    gap: 100px;

    .recharts-wrapper {
      margin-top: 20px;
      > svg {
        transform: translate(30%, -20%);
      }
    }

    .recharts-legend-wrapper {
      top: 0 !important;
      bottom: 0 !important;
      width: 100% !important;
      display: flex;
      align-items: center;
    }

    .recharts-default-legend {
      transform: translateY(-40%);
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 10px;
    }

    .recharts-legend-item {
      margin-right: 30px !important;
      display: flex;
      align-items: center;

      svg {
        transform: translateY(-2px);
      }
    }

    .project-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 10px;
      margin-bottom: 10px;
      padding: 10px;
      max-height: 360px;
      overflow-y: scroll;
      background-color: #fff;

      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        background: rgba(30, 54, 102, 1);
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(30, 54, 102, 1);
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }

      .item {
        box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px,
          rgba(0, 0, 0, 0.24) 0px 1px 2px;
        width: 400px;
        background: #f5f5f5;
        color: #fff;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        &.active {
          background-color: #3d85c6;
          p {
            color: #fff;
          }
        }

        p {
          color: rgba(0, 0, 0, 0.25);
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }

  .select {
    width: 180px;
    margin-left: 10px;
  }

  .button {
    border-radius: 8px;
  }

  .ant-tabs-top > .ant-tabs-nav {
    border-bottom: none;
  }

  .Toolbar-toolbar {
    border-bottom: none !important;
  }
`;
